import React from 'react'

import styled from 'styled-components'
import media from 'utils/media'

import FontAwesome from 'components/FontAwesome'

const Quote = ({ author, text }) => (
   <Wrapper>
      <FontAwesome icon={'quoteLeft'} />
      <blockquote>{text}</blockquote>
      <cite>{author}</cite>
   </Wrapper>
)

export default Quote

const Wrapper = styled.div`
   margin-top: 28px;
   margin-bottom: 28px;
   margin-left: calc(50% - 50vw);
   margin-right: calc(50% - 50vw);
   padding-top: 39px;
   padding-bottom: 57px;
   padding-left: 33px;
   padding-right: 33px;
   text-align: center;
   background: ${({ theme }) => theme.colors.quoteBg};

   ${media.greaterThan('sm')`
    margin-left: calc(-100vw / 2 + 520px / 2);
    margin-right: calc(-100vw / 2 + 520px / 2);
    padding-left: calc((100vw - 520px) / 2);
    padding-right: calc((100vw - 520px) / 2);
  `};

   ${media.greaterThan('md')`
    margin-top: 51px;
    margin-bottom: 51px;
    margin-left: calc(-100vw / 2 + 580px / 2);
    margin-right: calc(-100vw / 2 + 580px / 2);
    padding-top: 48px;
    padding-bottom: 75px;
    padding-left: calc((100vw - 680px) / 2);
    padding-right: calc((100vw - 680px) / 2);
  `};

   ${media.greaterThan('lg')`
    margin-top: 72px;
    margin-bottom: 72px;
    margin-left: calc(-100vw / 2 + 580px / 2);
    margin-right: calc(-100vw / 2 + -30px / 2);
    padding-top: 100px;
    padding-bottom: 101px;
    padding-left: calc((100vw - 300px) / 2);
    padding-right: calc((100vw - 500px) / 2);
  `};

   svg {
      color: ${({ theme }) => theme.colors.dark};
      margin-bottom: 24px;

      ${media.greaterThan('md')`
      margin-bottom: 40px;
    `};
   }

   blockquote {
      font-size: 27px;
      line-height: 1.3;
      letter-spacing: -0.4px;
      font-family: ${({ theme }) => theme.fonts.portrait};
      color: ${({ theme }) => theme.colors.quoteText};
      margin-bottom: 70px;

      ${media.greaterThan('md')`
      font-size: 38px;
      line-height: 1.24;
      letter-spacing: -0.5px;
    `};
   }

   cite {
      line-height: 0.88;
      font-style: normal;
   }
`
